import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";
import { RegisterActionListener } from "../state/State.js";
import { GameActions } from "../state/GameReducer.js";

/**
 * @name BaseHeal
 * @class BaseHeal
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class BaseHeal extends HTMLElement {
  static observedAttributes = ["player"];
  amountHealed = 1;

  constructor() {
    super();
    RegisterActionListener(GameActions.heal, (e) => {
      console.log("🧙‍♂️: State updated BaseHeal", e);
      if (e.player !== this.getAttribute("player")) return;
      this.amountHealed = e.amount;
      this.render();
      this.triggerAnimation();
    });
  }

  triggerAnimation() {
    const overlay = this.querySelector("#heal-overlay");
    overlay.classList.remove("hidden");
    setTimeout(() => {
      overlay.classList.add("hidden");
    }, 1000);
    const images = this.querySelectorAll("img");
    images.forEach((image) => {
      image.classList.add("fade-out-up");
      setTimeout(() => {
        image.classList.remove("fade-out-up");
      }, 900);
    });
    const heading = this.querySelector("h2");
    heading.classList.add("bounce-out");
    setTimeout(() => {
      heading.classList.remove("bounce-out");
    }, 900);
  }

  render() {
    new Audio("/assets/sound/heal.mp3").play();
    this.innerHTML = `
      <div
        class="hidden bottom-0 justify-center items-center flex-col w-full h-full flex z-40 absolute max-h-[300px]"
        id="heal-overlay"
      >
        <h2 class="text-shadow hidden bottom-[30%] font-extrabold text-center absolute font-normal text-2xl z-50">
          Healing ${this.amountHealed} damage
        </h2>
        <img
          class="drop-shadow-white hidden absolute icon-1"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-2"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-3"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-4"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-5"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-6"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
        <img
          class="drop-shadow-white hidden absolute icon-7"
          alt="Healing cross"
          height="24"
          loading="lazy"
          src="/assets/icons/heal-green.svg"
          width="24"
        />
      </div>
      `;
  }

  connectedCallback() {
    this.render();
  }
}
